// extracted by mini-css-extract-plugin
export default {"ReplyButton":"pf_a bhf_wv bhf_iz bhf_xj bhf_i bhf_j bhf_q bhf_vr bhf_er bhf_sm bhf_sn bhf_eb","ReplyButton__icon":"pf_b bhf_rx"};